<div class="json-metadata-container">
  <h4 class="json-title">{{ label }}</h4>
  <div #jsonContainer class="json-viewer-container"></div>
</div> 